export enum FirebaseCollection {
  Locations = 'locations',
  LastModified = 'lastModified'
}
